import { lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LoginPage } from './features/auth/components/LoginPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { CompanyRedirect, ContactRedirect } from './components/LegacyRedirects';

// Lazy: everything behind the login/Layout boundary is code-split so
// the app doesn't ship in the initial bundle. See apps/elka-manager & apps/quotes
// App.tsx for the same pattern.
const MyDashboardPage = lazy(() =>
  import('./pages/MyDashboardPage').then((m) => ({ default: m.MyDashboardPage }))
);
const PipelinePage = lazy(() =>
  import('./pages/PipelinePage').then((m) => ({ default: m.PipelinePage }))
);
const CustomersPage = lazy(() =>
  import('./pages/CustomersPage').then((m) => ({ default: m.CustomersPage }))
);
const CustomerDetailPage = lazy(() =>
  import('./pages/CustomerDetailPage').then((m) => ({ default: m.CustomerDetailPage }))
);
const DealDetailPage = lazy(() =>
  import('./pages/DealDetailPage').then((m) => ({ default: m.DealDetailPage }))
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/my-dashboard" replace />} />
          <Route path="my-dashboard" element={<MyDashboardPage />} />
          <Route path="pipeline" element={<PipelinePage />} />
          <Route path="deals/:dealId" element={<DealDetailPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="customers/:companyId" element={<CustomerDetailPage />} />
          {/* Legacy URLs from before the redesign. Tasks moved to the tasks app; old push
              notifications still point at /tasks. */}
          <Route path="tasks" element={<Navigate to="/my-dashboard" replace />} />
          <Route path="dashboard" element={<Navigate to="/pipeline" replace />} />
          <Route path="reports" element={<Navigate to="/pipeline" replace />} />
          <Route path="deals" element={<Navigate to="/pipeline" replace />} />
          <Route path="companies" element={<Navigate to="/customers" replace />} />
          <Route path="companies/:companyId" element={<CompanyRedirect />} />
          <Route path="contacts" element={<Navigate to="/customers" replace />} />
          <Route path="contacts/:contactId" element={<ContactRedirect />} />
          <Route path="activities" element={<Navigate to="/my-dashboard" replace />} />
          <Route path="*" element={<Navigate to="/my-dashboard" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
